import * as Sentry from '@sentry/vue';
import { SENTRY_ENVIRONMENT, SENTRY_DSN, VUE_APP_ROOT_API } from '@/transformEnv';

const release = import.meta.env.VITE_APP_RELEASE;

/**
 * @description Плагин для Sentry-мониторинга.
 * @param {VueRouter} router
 * @constructor
 * @type {VuePlugin}
 */
export default function SentryPlugin(router) {
  this.install = (Vue) => {
    Sentry.init({
      autoSessionTracking: true,
      dsn: SENTRY_DSN,
      environment: SENTRY_ENVIRONMENT,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      release,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      tracePropagationTargets: [VUE_APP_ROOT_API],
      tracesSampleRate: 0.1,
      Vue,
    });
  };
}
